<div class="page-edge">
  <div class="page-wrapper">
    <app-tab-nav></app-tab-nav>
  </div>
  <ng-container
    *ngIf="(shareScreenSize$ | async | detectScreenSizes:tabletBreakPoint) as isMobile"
  >
    <ng-container *ngTemplateOutlet="dcFilterTemp; context: { isMobile: isMobile }"></ng-container>
  </ng-container>
</div>
<div class="component-breakpoint">
  <!-- Reference for new Boostrap 4 classes: -->
  <!-- @link https://stackoverflow.com/questions/35351353/missing-visible-and-hidden-in-bootstrap-v4 -->
  <div class="breakpoint breakpoint-xs d-block d-sm-none" data-breakpoint="xs"></div>
  <div class="breakpoint breakpoint-sm d-none d-sm-block d-md-none" data-breakpoint="sm"></div>
  <div class="breakpoint breakpoint-md d-none d-md-block d-lg-none" data-breakpoint="md"></div>
  <div class="breakpoint breakpoint-lg d-none d-lg-block d-xl-none" data-breakpoint="lg"></div>
  <div class="breakpoint breakpoint-xl d-none d-xl-block" data-breakpoint="xl"></div>
</div>
<app-spinner></app-spinner>

<ng-template #dcFilterTemp>
  <div class="module-modal modal mobile-fullscreen filter-modal modal-sticky-footer filter-modal-catalog bigger-than-screen"
    [ngClass]="{ 'show animate': mobileDisplayFilters }" data-plugin="moduleModal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-close">
          <div class="module-button filter-modal-catalog">
            <button type="button" attr.aria-label="{{'dc.myrn.button.close-filter-popup' | translate}}"
              class="btn btn-link" (click)="mobileDisplayFilters = false">
            </button>
            <div class="button-animation"></div>
            <div class="button-content">
              <i class="icon icon-dc_close"></i>
            </div>
          </div>
        </div>
        <div class="modal-header">
          <p class="headline h5 modal-title">
            <span class="bundle">{{ 'dc.myrn.filter.filter-by' | translate }}</span>
          </p>
        </div>
        <div class="modal-body">
          <ng-container *ngIf="mobileFilters">
            <dc-filter [searchByText]="mobileFilters!.searchByText | async" [filters]="mobileFilters!.filters"
              [filterCounts]="mobileFilters!.filterCounts" [filterByText]="mobileFilters!.filterByText"
              [showMoreText]="'dc.myrn.filter.show-more' | translate"
              [showLessText]="'dc.myrn.filter.show-less' | translate" [clearAllText]="mobileFilters!.clearAllText"
              [selectedFilterText]="mobileFilters!.selectedFilterText"
              [skipNullCounts]="mobileFilters!.skipNullCounts">
            </dc-filter>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-template>
